import React from 'react';

export default function AdminPageHeader({ badge, title, description, actions }) {
  return (
    <header className="adm-page-header adm-no-print mb-4">
      <div className="adm-page-header__main">
        <div className="adm-page-header__text">
          {badge && <span className="adm-page-header__badge">{badge}</span>}
          <h1 className="adm-page-title mb-1">{title}</h1>
          {description && <p className="adm-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="adm-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
